import { useHttp } from '@/shared/lib'
import { keepPreviousData, useQuery } from '@tanstack/vue-query'
import { computed, type Ref } from 'vue'
import { mapSuggestions } from './mapSuggestions'
import { normalizeSuggestQuery } from './normalizeQuery'

/** Ниже трёх символов выдача ФИАС слишком широкая, а запрос идёт по всей таблице. */
export const ADDRESS_SUGGEST_MIN_CHARS = 3

/**
 * Без набранного номера ручка отдаёт улицу вместе с её домами, поэтому лимит
 * заметно больше «одного экрана»: список прокручивается, а дома одной улицы
 * должны в него поместиться. Потолок ручки — 50.
 */
export const ADDRESS_SUGGEST_LIMIT = 20

/**
 * Подсказки адресов из fias-service через api-gateway.
 * Регион не передаётся: база сервиса однорегиональная (FIAS_REGION_CODE).
 */
export const useAddressSuggest = (search: Ref<string>) => {
  const http = useHttp()

  const query = computed(() => normalizeSuggestQuery(search.value))
  const isEnabled = computed(() => query.value.length >= ADDRESS_SUGGEST_MIN_CHARS)

  const result = useQuery({
    queryKey: ['fias_suggest', query],
    queryFn: async () => {
      const response = await http.get('/fias/suggest', {
        q: query.value,
        limit: ADDRESS_SUGGEST_LIMIT,
      })

      return mapSuggestions(response.data)
    },
    enabled: isEnabled,
    retry: false,
    staleTime: 5 * 60 * 1000,
    placeholderData: keepPreviousData,
  })

  /** Пока порог не набран, прошлая выдача не должна висеть в открытом меню. */
  const items = computed(() => (isEnabled.value ? (result.data.value ?? []) : []))

  return {
    items,
    isFetching: result.isFetching,
    isError: result.isError,
    isEnabled,
  }
}
